"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactIDProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_id_context_1 = require("./react-id-context");
var ReactIDProvider = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? 'id' : _b;
    var parentContext = (0, react_1.useContext)(react_id_context_1.ReactIDContext);
    var counter = (0, react_1.useRef)(0);
    var getID = (0, react_1.useCallback)(function () { return "".concat(prefix, "-").concat(counter.current++); }, [prefix]);
    return (react_1.default.createElement(react_id_context_1.ReactIDContext.Provider, { value: parentContext !== react_id_context_1.defaultContextValue ? parentContext : getID }, children));
};
exports.ReactIDProvider = ReactIDProvider;
//# sourceMappingURL=react-id-provider.js.map